import type { ButtonSize } from '@wix/design-system';
import { Button } from '@wix/design-system';
import React from 'react';
import { useTranslation } from '../../../../contexts/translations-context';
import { useSiteContext } from '../../../../contexts';

export const UPGRADE_APP_BUTTON_DATA_HOOK = 'upgrade-app-button';

export interface UpgradeAppButtonProps {
  appId: string;
  size: ButtonSize;
}

export function UpgradeAppButton({ appId, size }: UpgradeAppButtonProps) {
  const { t } = useTranslation();
  const { metaSiteId } = useSiteContext();

  return (
    <Button
      skin="premium"
      dataHook={UPGRADE_APP_BUTTON_DATA_HOOK}
      size={size}
      onClick={() => {
        const appPackagePickerUrl = `https://www.wix.com/apps/upgrade/${appId}?metaSiteId=${metaSiteId}&pp_origin=app_market_app_page`;
        window.open(appPackagePickerUrl);
      }}
    >
      {t('app.page.upgrade.cta.label')}
    </Button>
  );
}
